import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Bearer-token fallback: on custom production domains the SameSite=None auth
// cookie is treated as third-party and blocked by the browser, so we also
// store the JWT and send it as an Authorization header (backend accepts both).
const TOKEN_KEY = "ep_admin_token";
export const setAuthToken = (t) => {
  try { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); } catch (e) { /* ignore */ }
};
export const getAuthToken = () => {
  try { return localStorage.getItem(TOKEN_KEY); } catch (e) { return null; }
};

// URL for a protected media asset usable in an <img> tag: appends the JWT as a
// query param since <img> cannot send an Authorization header (needed when the
// auth cookie is blocked as third-party on production custom domains).
export const mediaUrl = (id) => {
  const t = getAuthToken();
  return `${API}/media/${id}/raw${t ? `?token=${encodeURIComponent(t)}` : ""}`;
};

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const t = getAuthToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// On session loss (401) inside the admin area, clear the token and redirect once
// to the login screen instead of leaving broken "Not authenticated" errors.
let _redirecting = false;
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    const inAdmin = typeof window !== "undefined" && window.location.pathname.startsWith("/blueprint-os");
    if (status === 401 && inAdmin && !url.includes("/auth/") && !_redirecting) {
      _redirecting = true;
      setAuthToken(null);
      window.location.assign("/blueprint-os");
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
